import { UserForm } from "../../../c/UserForm"
import UsersContext from "../../../contexts/usersContext"
import React, { useContext } from "react"
import { Modal } from "reactstrap"
import { TraksConsumer } from "../../../traks"


export const EditUser = ({saveUserSettings, meta, ...props}) => {
	const {editUser, setEditUser} = useContext(UsersContext)

	const handleSaveSettings = (userSettings) => {
		saveUserSettings(userSettings)
		setEditUser(undefined)
	}

	return(
		<Modal 
			isOpen={editUser !== undefined} 
			toggle={() => setEditUser()} className={"modals"}
			style={{maxWidth: "800px"}}
		>
			<TraksConsumer>
			<UserForm
				actionType={"EditUser"}
				signupOnClick={handleSaveSettings}
				preSetUser={editUser}
				roles={meta.roles}
				hideAddUser={() => setEditUser(undefined)}
			/>
			</TraksConsumer>
		</Modal>
	)
}
